import React from 'react';
import PropTypes from 'prop-types';

export const RegistryVendor = (props) => {
  const {type, registry, dataQaId} = props;
  const {name} = registry;
  const iconUrl = registry.iconUrl || registry.icon_url;
  const vendorName = registry.vendorName || registry.vendor_name || registry.name;

  let displayName = name;
  if (vendorName) {
    displayName = vendorName.includes('registry')
      ? vendorName.replace('registry', type)
      : `${vendorName} ${type}`;
  }

  return (
    <a
      href={registry.url || ''}
      className="view-invitation__registry-vendor"
      target="_blank"
      data-qa-id={dataQaId}
      data-impression-tracking="true"
      rel="noreferrer"
    >
      <img src={iconUrl} alt={vendorName} />
      <div className="view-invitation__registry-vendor__cta">
        <p className="view-invitation__registry-vendor__cta-text">View the {displayName}</p>
      </div>
    </a>
  );
};

RegistryVendor.propTypes = {
  registry: PropTypes.shape({
    email_reg_button_url: PropTypes.string,
    icon_url: PropTypes.string,
    iconUrl: PropTypes.string,
    name: PropTypes.string,
    sg_icon_url: PropTypes.string,
    type: PropTypes.string,
    url: PropTypes.string.isRequired,
    vendor_name: PropTypes.string,
    vendorName: PropTypes.string,
  }).isRequired,
  dataQaId: PropTypes.string.isRequired,
};
